import { render } from "./base-callout.vue?vue&type=template&id=741b52cb"
const script = {}

import exportComponent from "/Users/blackend/Desktop/hay-gas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__